import React, { useEffect, useState } from "react";
import "./ActiveCategorypic.css";
import category1 from "../../assets/category/category_1.png";
import category2 from "../../assets/category/category_2.png";
import category3 from "../../assets/category/category_3.png";
import category4 from "../../assets/category/category_4.png";
import category5 from "../../assets/category/category_5.png";
import category6 from "../../assets/category/category_6.png";
import category7 from "../../assets/category/category_7.png";
import category8 from "../../assets/category/category_8.png";
import category9 from "../../assets/category/category_9.png";
import category10 from "../../assets/category/category_10.png";
import { AiOutlineClose } from "react-icons/ai";
import { useSelector } from "react-redux";
import SearchComponent from "../searchcomponent/SearchComponent";
import { getColor } from "../../utility/lettercolor";
const categoryImages = {
  1: category1,
  2: category2,
  3: category3,
  4: category4,
  5: category5,
  6: category6,
  7: category7,
  8: category8,
  9: category9,
  10: category10,
};

const ActiveCategorypic = (props) => {
  const [categoryData, setCategoryData] = useState([]);
  const [search, setSearch] = useState("");

  const activecategorydataarr = useSelector(
    (state) => state?.trackhrcategory?.activeCategoryDataArr || {}
  );

  useEffect(() => {
    setCategoryData(Object.keys(activecategorydataarr));
  }, [activecategorydataarr]);

 
  const lettercolor = (categoryID) => {
    const bgColor = getColor(categoryID);
    if(!bgColor) return
    const r = parseInt(bgColor.substr(1, 2), 16);
    const g = parseInt(bgColor.substr(3, 2), 16);
    const b = parseInt(bgColor.substr(5, 2), 16);
    const luminance = (r * 299 + g * 587 + b * 114) / 1000;
    return luminance > 128 ? "black" : "white";
  };


  const getCategoryRaw = (id) => activecategorydataarr[id];

  const getCategoryName = (id) =>
    getCategoryRaw(id)?.split("$-")[0] || "";

  const getsubcategory = (id) =>
    getCategoryRaw(id)?.split("$")[2] || "";

  const getName = (id) =>
    getCategoryRaw(id)?.split("$-")[0]?.[0] || "";


  const getResponse = (categoryID) => {
    if (categoryImages[categoryID]) {
      return <img src={categoryImages[categoryID]} alt="" />;
    }

    return (
      <div
        className="category"
        id="categoryBox"
        style={{ backgroundColor: getColor(categoryID,activecategorydataarr) }}
      >
        <span style={{ color: lettercolor(categoryID), fontSize: "20px" }}>
          {getName(categoryID)}
        </span>
      </div>
    );
  };

 
  const storeSearch = (val) => {
    setSearch(val);

    if (!val) {
      setCategoryData(Object.keys(activecategorydataarr));
      return;
    }

    const filtered = Object.keys(activecategorydataarr).filter((id) =>
      getCategoryName(id).toLowerCase().includes(val.toLowerCase()) ||
      getsubcategory(id).toLowerCase().includes(val.toLowerCase())
    );

    setCategoryData(filtered);
  };

 
  const sendCategoryID = (categoryID) => {
    props.fun(categoryID);
    props.funForExitModal(false);
  };


  return (
    <>
    
      <div
        style={{
          height: "50px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          gap:"10px",
          paddingTop:"10px"
        }}
      >
        <p  className="isp" style={{ fontSize: "18px", whiteSpace:"nowrap", color: "#0cc1e6", fontWeight: 500 }}>
          Select Category
        </p>

        <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
          <SearchComponent
            searchvalue={search}
            storeSearch={storeSearch}
          />
         <div className="close-wrapper">
  <AiOutlineClose 
    className="close-icon-cate"
    onClick={props.close}
  />
</div>

          
        </div>
      </div>

 
      <div
        style={{
          height: "385px",
          overflowY: "scroll",
          overflowX: "hidden",
          paddingLeft: "10px",
        }}
      >
        {categoryData.length > 0 ? (
          categoryData.map((id) => (
            <div
              key={id}
              className="row categoryRow"
              onClick={() => sendCategoryID(id)}
            >
              <div className="col-md-2 col-2 categorypicbox">
                {getResponse(id)}
              </div>

              <div className="col-md-10 col-10 categorySpan">
                <p className="isp">{getCategoryName(id)}</p>
                <p  className="isp" style={{ fontSize: "12px", color: "black" }}>
                  {getsubcategory(id)}
                </p>
              </div>
            </div>
          ))
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              color: "#ff6d00",
            }}
          >
            <p  className="isp">No Record</p>
          </div>
        )}
      </div>
    </>
  );
};

export default ActiveCategorypic;
